import { render, staticRenderFns } from "./simple-text-modal.vue?vue&type=template&id=4e30be4f&scoped=true&"
import script from "./simple-text-modal.vue?vue&type=script&lang=js&"
export * from "./simple-text-modal.vue?vue&type=script&lang=js&"
import style0 from "./simple-text-modal.vue?vue&type=style&index=0&id=4e30be4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e30be4f",
  null
  
)

export default component.exports